import React, { Component } from 'react'
import { persistStore } from 'redux-persist'
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom'
import { connect } from 'react-redux'
import styled from 'styled-components'
import t from 'prop-types'

import Util from 'helpers/Util'
import Color from 'helpers/Color'
import { Notifications } from 'components/UI'

import Auth from 'store/Auth'
import Constants from 'helpers/Constants'
import MainMenu from './MainMenu'
import ScrollToTop from './ScrollToTop'

import Login from 'components/Login'
import Overview from 'components/Overview'
import Building from 'components/Building'
import BuildingList from 'components/Building/BuildingList'
import Unit from 'components/Unit'
import UnitList from 'components/Unit/UnitList'
import Line from 'components/Line'
import LineList from 'components/Line/LineList'
import Floor from 'components/Floor'
import BuildingAlertList from 'components/Alert/BuildingAlertList'
import Profile from 'components/Profile'
import AlertList from 'components/Alert/AlertList'
import Radiator from 'components/Radiator'

const Wrapper = styled(ScrollToTop)`
  height: 100%;
  color: ${Color.darkGray};
`
const AppContainer = styled.div`
  max-width: ${Constants.pageWidth}px;
  margin: auto;

  ${Util.desktopOnly} {
    padding: 0 80px;
  }

  ${Util.mobileOnly} {
    padding: 107px 20px 0 20px;
  }
`

const menuItems = [
  {name: 'Overview', path: '/', exact: true},
  {name: 'Buildings', path: '/buildings', otherPaths: ['/radiators', '/units', '/lines']},
  {name: 'Alerts', path: '/alerts'},
]

class App extends Component {
  state = {
    rehydrated: false,
  }

  componentWillMount(){
    // Get Redux state info from localstorage.
    // Wait until it is done before rendering the app.
    persistStore(this.props.store, {
      blacklist: ['notification'],
    }, () => {
      this.setState({ rehydrated: true })
    })
  }

  render() {
    const {
      userDetails,
      authStatus,
    } = this.props

    if (!(authStatus === Auth.LOGGED_IN)) {
      return (
        <div>
          <Notifications />
          <Login rehydrated={this.state.rehydrated} />
        </div>
      )
    }

    return (
      <Router>
        <Wrapper>
          <Notifications />
          <MainMenu
            user={userDetails}
            items={menuItems}
          />
          <AppContainer>
            <Route exact path='/' component={Overview}/>
            <Route exact path='/buildings' component={BuildingList}/>
            <Route exact path='/buildings/:buildingId' component={Building}/>
            <Route exact path='/buildings/:buildingId/units' component={UnitList}/>
            <Route exact path='/buildings/:buildingId/lines' component={LineList}/>
            <Route exact path='/units/:unitId' component={Unit}/>
            <Route exact path='/lines/:lineId' component={Line}/>
            <Route exact path='/floors/:floorId' component={Floor}/>
            <Route exact path='/radiators/:radiatorId' component={Radiator}/>
            <Route exact path='/alerts' component={AlertList}/>
            <Route exact path='/alerts/:buildingId' component={BuildingAlertList}/>
            <Route exact path='/user' component={Profile}/>
          </AppContainer>
        </Wrapper>
      </Router>
    )
  }
}

App.propTypes = {
  userDetails: t.object,
  authState: t.string,
  store: t.object,
}

const mapStateToProps = state => ({
  authStatus: state.auth.status,
  userDetails: state.auth.userDetails,
})

export default connect(mapStateToProps)(App)



// WEBPACK FOOTER //
// ./src/components/App/App.jsx